import React from "react";
import { GolfHeaderContainer } from "../organisms/golfHeaderContainer";
import GolfSoloCompleteContainer from "../organisms/golfSoloCompleteContainer";
import { SubHeader } from '../molecules/subHeader';
import SubHeader4 from '../../resources/image/subHeader4.png';
import GolfReservationPopupContainer from "../organisms/golfReservationPopupContainer";
import { connect } from "react-redux";
import '../../resources/css/soloReserve/golfSoloComplete.css'
import { GolfSoloHeaderContainer } from "../organisms/golfSoloHeaderContainer";
import GolfSoloReservationPopupContainer from "../organisms/golfSoloReservationPopupContainer";

class GolfSoloCompleteTemplate extends React.Component {

  render() {
    return (
      <div className="soloComplete_max_height">
        <GolfSoloHeaderContainer
          Label categoryLabel1={"予約完了"}
          categoryLabel2={"COMPLETE"}
          onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
        />
        <GolfSoloReservationPopupContainer
            state={this.props.state}
            onClickClosePopupWindow={this.props.onClickClosePopupWindow}
        />
        <GolfSoloCompleteContainer 
          completeTitle={"ご予約を承りました"} 
          completeBody={"お申込内容をメールでお送りいたしましたので、"}
          completeBody2={"内容をご確認ください。"}
          dispName={"complete"}/>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
      changeReserveNo:state.changeReserveNo,
  };
};
const mapToDispatchToProps = (dispatch) => {
  return {
  };
}
export default connect(mapStateToProps, mapToDispatchToProps)(GolfSoloCompleteTemplate);